import React, { useState } from 'react';
import './LoginScreen.css';
import { userSignIn } from '../firebase/auth-helper';

const LoginScreen: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email || !password) {
      setError('Bitte fülle alle Felder aus.');
      return;
    }

    try {
      setError(null);
      const success = await userSignIn(email, password);
      if (!success) setError('Zugangsdaten fehlerhaft');
    } catch (error) {
      setError('Login nicht erfolgreich');
    }
  };

  return (
    <div className="login-container">
      <div className="login-logo">
        <img src="/img/logo_black.svg" alt="Logo" />
      </div>
      <div className="login-form-container">
        <h2 className="login-title">Anmelden</h2>
        <form className="login-form" onSubmit={handleLogin}>
          {error && <p className="login-error">{error}</p>}
          <div className="login-input-group">
            <label htmlFor="email" className="login-label">
              E-Mail
            </label>
            <input
              id="email"
              type="email"
              className="login-input"
              placeholder="Deine E-Mail-Adresse"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="login-input-group">
            <label htmlFor="password" className="login-label">
              Passwort
            </label>
            <input
              id="password"
              type="password"
              className="login-input"
              placeholder="Dein Passwort"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="login-button">
            Einloggen
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
